import { useState } from "react";
import axios from "axios";
import { springBaseUrl } from "../../constants/AmplitudeConstants";

const usePrintRegistrationCard = (bookingId, manualResCard) => {
  const [printLoading, setPrintLoading] = useState(false);
  const [printSuccess, setPrintSuccess] = useState(false);
  const hotelId = new URL(window.location.href).searchParams.get("hotelId");
  const generatedResCardUrl = `${springBaseUrl}core/api/v1/rescard/get-rescard?bookingId=${bookingId}&fillDetails=${!manualResCard}`;
  const signedPdfUrl = `${springBaseUrl}web-api/get-registration-card-pdf/?hotelId=${hotelId}&bookingId=${bookingId}`;

  const openPdfBlob = (response) => {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  };

  const handlePrintRegCard = async () => {
    setPrintLoading(true);
    setPrintSuccess(false);
    try {
      let response;
      if (manualResCard) {
        response = await axios.get(generatedResCardUrl, {
          headers: {
            Accept: "application/pdf",
            Authorization: localStorage.getItem("token"),
          },
          responseType: "blob",
        });
      } else {
        try {
          response = await axios.get(signedPdfUrl, {
            headers: {
              Accept: "application/pdf",
              Authorization: localStorage.getItem("token"),
            },
            responseType: "blob",
          });
        } catch (err) {
          console.warn(
            "Signed registration card fetch failed. Falling back to generated registration card.",
            {
              bookingId,
              hotelId,
              status: err?.response?.status,
              message: err?.message,
            }
          );
          response = await axios.get(generatedResCardUrl, {
            headers: {
              Accept: "application/pdf",
              Authorization: localStorage.getItem("token"),
            },
            responseType: "blob",
          });
        }
      }

      setPrintSuccess(true);
      openPdfBlob(response);
    } catch (_) {
    } finally {
      setPrintLoading(false);
    }
  };

  return {
    printLoading,
    printSuccess,
    handlePrintRegCard,
  };
};

export default usePrintRegistrationCard;
